import axios, { AxiosError } from "axios";
import { toast } from "react-toastify";

type ServerError =
  | { message?: string; error?: string; detail?: string; errors?: unknown }
  | string
  | null
  | undefined;

export function handleApiError(error: unknown, silent = false): string {
  let message = "یک خطای ناشناخته رخ داد.";

  if (axios.isAxiosError(error)) {
    const axiosErr = error as AxiosError<ServerError>;
    const status = axiosErr.response?.status;

    const data = axiosErr.response?.data;
    const serverMessage =
      (typeof data === "string" ? data : data?.message || data?.error || data?.detail) ??
      undefined;

    if (serverMessage) {
      message = serverMessage;
    } else if (status) {
      const messages: Record<number, string> = {
        400: "درخواست نامعتبر است.",
        401: "شما دسترسی ندارید.",
        403: "شما دسترسی ندارید.",
        408: "پایان زمان پاسخ سرور.",
        500: "مشکل در عدم ارتباط با سرور!",
      };
      message = messages[status] || `خطا با کد: ${status}`;
    } else if (axiosErr.request) {
      message = "پاسخی از سرور دریافت نشد.";
    } else if (axiosErr.message) {
      message = axiosErr.message;
    }
  } else if (error instanceof Error) {
    message = error.message || message;
  }

  if (!silent) {
    toast.error(message, { toastId: `api-error:${message}` });
  }

  return message;
}
